// extracted by mini-css-extract-plugin
var _1 = "t62hIFJ1aQFqVCAsSN2X";
export { _1 as "inner" }
